import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase"; // functions instance

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  // 🔑 CUSTOM TOKEN (not oobCode)
  const token = params.get("token");

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token) {
      setError("Invalid or expired reset link");
      return;
    }

    if (password.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }

    if (password !== confirm) {
      setError("Passwords do not match");
      return;
    }

    try {
      setLoading(true);
      setError("");

      // 🔥 CALL YOUR CUSTOM CLOUD FUNCTION
      const confirmResetPassword = httpsCallable(
        functions,
        "confirmResetPassword"
      );

      await confirmResetPassword({
        token,
        newPassword: password,
      });

      navigate("/reset-success");
    } catch (err) {
      console.error(err);

      setError(
        err?.message ||
          "Reset link expired or invalid. Please request a new one."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={styles.title}>Reset your password</h2>
        <p style={styles.subtitle}>
          Choose a strong password to secure your account
        </p>

        {error && <p style={styles.error}>{error}</p>}

        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="password"
            placeholder="New password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
          />

          <input
            type="password"
            placeholder="Confirm password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            style={styles.input}
          />

          <button disabled={loading} style={styles.button}>
            {loading ? "Resetting..." : "Reset Password"}
          </button>
        </form>
      </div>
    </div>
  );
}

/* ------------------ skilll.dev styles ------------------ */

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "radial-gradient(circle at top, #020617, #000)",
    padding: 16,
  },

  card: {
    width: "100%",
    maxWidth: 420,
    background: "#0F172A",
    border: "1px solid #1E293B",
    borderRadius: 14,
    padding: "28px 26px",
    boxShadow: "0 20px 40px rgba(0,0,0,0.6)",
  },

  title: {
    color: "#E5E7EB",
    fontSize: 22,
    fontWeight: 600,
    marginBottom: 6,
  },

  subtitle: {
    color: "#94A3B8",
    fontSize: 14,
    marginBottom: 20,
  },

  form: {
    display: "flex",
    flexDirection: "column",
    gap: 14,
  },

  input: {
    background: "#020617",
    border: "1px solid #1E293B",
    borderRadius: 10,
    padding: "12px 14px",
    color: "#E5E7EB",
    fontSize: 14,
    outline: "none",
  },

  button: {
    marginTop: 6,
    padding: "12px",
    borderRadius: 10,
    border: "none",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: 14,
    color: "#fff",
    background: "linear-gradient(90deg, #2563EB 0%, #7C3AED 100%)",
    opacity: 1,
  },

  error: {
    background: "rgba(239,68,68,0.12)",
    color: "#FCA5A5",
    padding: "10px 12px",
    borderRadius: 8,
    fontSize: 13,
    marginBottom: 12,
  },
};
